import { useCallback, useState, useRef, useEffect } from "react"

import { ExecutionRun } from "@vertesia/common"

import { useEventSource } from "@hooks/use-event-source"

import { useUserSession } from "@session/UserSession"

interface ServiceStreamingPanelProps {
    run: ExecutionRun
    onStreamingDone?: (content: string) => void
}
export function ServiceStreamingPanel({ run, onStreamingDone }: Readonly<ServiceStreamingPanelProps>) {
    const [text, setText] = useState("")
    const session = useUserSession()
    const scrollContainerRef = useRef<HTMLPreElement>(null)
    const currentTextRef = useRef("")

    const onMessage = (text: string) => {
        setText(text)
        currentTextRef.current = text
    }

    const onCompletion = (run: ExecutionRun) => {
        onStreamingDone?.(run.result)
    }

    useEffect(() => {
        if (scrollContainerRef.current) {
            const element = scrollContainerRef.current
            element.scrollTop = element.scrollHeight
        }
    }, [text])

    const urlFn = useCallback(async () => {
        const url = new URL(session.client.runs.getUrl(`/${run.id}/stream`))
        const token = await session.rawAuthToken
        if (!token) {
            throw new Error("No auth token available")
        }

        url.searchParams.set("access_token", token)
        return url.toString()
    }, [run, session.user?.sub, session.client.runs, session.rawAuthToken])

    useEventSource(urlFn, onMessage, onCompletion)

    let content
    if (text) {
        const lines = text.split("\n")
        content = lines.map((line, index) => {
            return <div key={index}>{line}</div>
        })
    }

    return (
        <pre ref={scrollContainerRef} className="h-full text-left overflow-auto whitespace-pre-wrap break-all">
            {content}
        </pre>
    )
}
